import {axiosInstance} from '../helper/appclient'
import get from 'lodash/get'
import {
    MFA_OTP_CODE_VERIFY_URL,
    MFA_SETUP_CODE_VERIFY_URL
} from '../config/url-config'
import {
    ERR_MSG, SESS_EXPIRED_TEXT, SUCCESS_CODES,
    MFA_CFM_ERR_103,
    MFA_CFM_ERR_100, MFA_CFM_ERR_101, MFA_OTP_WRONG_ERR,
} from "../constants/constants";
import {store} from "../store/store";
import {loadSessionExpired} from "../store/action";
import {extractStatusCode} from "../helper/responsehelper";

export const mfaSetupCodeVerifyResponseStatus = {
    [MFA_CFM_ERR_100]:SESS_EXPIRED_TEXT,
    [MFA_CFM_ERR_103]:MFA_OTP_WRONG_ERR,
    [MFA_CFM_ERR_101]:ERR_MSG,
    "UNK-ERR-102": ERR_MSG,
};
const constructMFASetupCodeVerify = (session,otpCode)=>(
    {
        session:session,
        otpCode:otpCode
    }

)
export const mfaSetupCodeVerifyService = (session,otpCode)=>{
    const codeVerifyRequest = constructMFASetupCodeVerify(session,otpCode)

    return new Promise((resolve,reject)=>{
        axiosInstance
            .post(MFA_SETUP_CODE_VERIFY_URL(),codeVerifyRequest)
            .then((response) => {

                let statusCode =extractStatusCode(response);
                if(SUCCESS_CODES.MFA_SETUP_CODE_VERIFY.includes(statusCode)){
                    resolve(response)
                }else{
                    let errText = mfaSetupCodeVerifyResponseStatus[statusCode]
                    if(errText === SESS_EXPIRED_TEXT){
                        store.dispatch(loadSessionExpired(true))
                    }
                    reject(errText || ERR_MSG )
                }
            })
            .catch((error) => {
                reject(ERR_MSG)
            });
    })
}